import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './../assets/images/back.png';
const _withScopeId = n => (_pushScopeId("data-v-449505db"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  "data-cfsrc": "./back.png",
  alt: "back",
  "data-cfstyle": "width: 30px; height: 30px;float: left;",
  style: {
    "width": "30px",
    "height": "30px",
    "float": "left"
  },
  src: _imports_0
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.handleBack && $setup.handleBack(...args)),
    style: {
      "box-sizing": "border-box",
      "padding": "15px",
      "height": "60px",
      "position": "sticky",
      "top": "0",
      "text-indent": "3em",
      "line-height": "30px",
      "font-size": "20px"
    }
  }, [_hoisted_1, _createTextVNode(" " + _toDisplayString($setup.name), 1)]);
}